import type { ProgramLevelSummary } from '../common/programs'

export const CONTENT_KINDS = {
  scenario: 'Lesson or diagnostic',
  program: 'Program',
  program_level: 'Program level',
  theme: 'Theme',
  tutor: 'Tutor',
  tutor_prompt: 'Tutor prompt',
} as const
export type ContentKind = keyof typeof CONTENT_KINDS
export type LifecycleStatus = 'draft' | 'active' | 'retired'
export interface HistoryTargetOption {
  id: string
  label: string
  requiresProgram: boolean
}
export interface HistoryTargetParams {
  targetType: ContentKind
  q?: string
  id?: string
}
export interface HistoryTargetOptions {
  items: HistoryTargetOption[]
  hasMore: boolean
  cefrLevels: ProgramLevelSummary['cefrLevel'][]
}
export interface ContentHistoryParams {
  targetType: ContentKind
  targetId: string
  from: string
  to: string
  programId?: string
  cefrLevel?: string
}
export interface ContentHistory {
  target: {
    targetType: ContentKind
    targetId: string
    programId: string | null
    cefrLevel: string | null
  }
  coverage: {
    start: string
    end: string
    observedUntil: string
    baselineAt: string | null
    statusComplete: boolean
    parentComplete: boolean
    callEvidenceComplete: boolean
    reasons: string[]
  }
  statusPeriods: {
    start: string
    end: string
    known: boolean
    status: LifecycleStatus | null
    inheritedStatus: LifecycleStatus | null
  }[]
  availabilityPeriods: {
    start: string
    end: string
    available: boolean | null
    blockers: { targetType: ContentKind; targetId: string; reason: string }[]
  }[]
  useEvidence: {
    retainedCallCount: number
    firstUse: string | null
    lastUse: string | null
    complete: boolean
    reasons: string[]
    scope: 'target' | 'target_and_program'
  }
}
